export class MISMOAmount {
	static AmountClass = {
		None: 0,
		Amount: 1
	};

	constructor(amount) {
			this.Value = null;
			this.Class = MISMOAmount.AmountClass.None;

			if (amount === null) return;
			if (typeof amount === 'string') {
				this.Value = Number(amount);
				this.Class = MISMOAmount.AmountClass.Amount;
			}
	}

	toString() {
		if (this.Class === MISMOAmount.AmountClass.None) return "";
		return String(this.Value);
	}

	ToString() {
		if (this.Class === MISMOAmount.AmountClass.None) return "";
		return String(this.Value);
	}

	HasValue() {
		return this.Class === MISMOAmount.AmountClass.Amount;
	}

	HasNonZeroValue() {
		if (this.Class === MISMOAmount.AmountClass.None) return false;
		if (this.Value === 0) return false;
		return true;
	}

	ToDollarAmount(replacement) {
		if (!replacement) replacement = "";
		if (this.Class === MISMOAmount.AmountClass.None) return replacement;
	  var value = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			negative: 'parenthesis',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
			currencySign: 'accounting'
			}).format(this.Value);
		return value;

	}
}